export class Status {
  static getMessage(statusCode: StatusCode): string {
    switch (statusCode) {
      case StatusCode.Success:
        return '@direction.pages.popupCredential.@status.success';
      case StatusCode.NotFound:
        return '@direction.pages.popupCredential.@status.notFound';
      case StatusCode.Expired:
        return '@direction.pages.popupCredential.@status.expired';
      case StatusCode.FinancialIssues:
        return '@direction.pages.popupCredential.@status.financialIssues';
      case StatusCode.Forbidden:
        return '@direction.pages.popupCredential.@status.forbidden';
      case StatusCode.Unknown:
        return '@direction.pages.popupCredential.@status.unknown';
      case StatusCode.TurnstileNotFound:
        return '@direction.pages.popupCredential.@status.turnstileNotFound';
      case StatusCode.StudentNotFound:
        return '@direction.pages.popupCredential.@status.studentNotFound';
      case StatusCode.NotFoundInUnit:
        return '@direction.pages.popupCredential.@status.notFoundInUnit';
      case StatusCode.InvalidToken:
        return '@direction.pages.popupCredential.@status.invalidToken';
    }
  }
}
export enum StatusCode {
  Success, //0 "Acesso liberado"
  StudentNotFound, //1 Aluno não cadastrado
  NotFound, //2 "Aluno nao encontrada!"
  NotFoundInUnit, //3 "Nao matriculado na unidade!"
  Expired, //4 "Credencial vencida!"
  FinancialIssues, //5 "Pendencias financeiras!"
  Forbidden, //6 "Horário nao permitido!",
  Unknown, //7 "Credencial Inexistente"
  TurnstileNotFound, //8 "Catraca não encontrada."
  InvalidToken //9 Token é inválido - ReleaseEntrance
}
